/**
 * 애찬부 소개 페이지
 */

import React from 'react';
import styled from '@emotion/styled';
import { MainLayout } from '../../../../shared/components';
import { theme } from '../../../../shared/styles/theme';
import { mediaQueries } from '../../../../shared/constants/breakpoints';

const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: ${theme.spacing.xxxl} ${theme.spacing.lg};

  ${mediaQueries.maxMobile} {
    padding: ${theme.spacing.xl} ${theme.spacing.md};
  }
`;

const PageTitle = styled.h1`
  font-size: ${theme.fontSizes.xxxl};
  font-weight: 700;
  color: ${theme.colors.primary};
  text-align: center;
  margin-bottom: ${theme.spacing.xl};
  font-family: ${theme.fonts.heading};

  ${mediaQueries.maxMobile} {
    font-size: ${theme.fontSizes.xxl};
  }
`;

const ImagePlaceholder = styled.div`
  width: 100%;
  max-width: 800px;
  height: 400px;
  margin: 0 auto ${theme.spacing.xl};
  background-color: ${theme.colors.border};
  border-radius: ${theme.borderRadius.lg};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.textLight};
  font-size: ${theme.fontSizes.lg};

  ${mediaQueries.maxMobile} {
    height: 250px;
  }
`;

const Section = styled.section`
  margin-bottom: ${theme.spacing.xxxl};
`;

const SectionTitle = styled.h2`
  font-size: ${theme.fontSizes.xxl};
  font-weight: 700;
  color: ${theme.colors.primary};
  margin-bottom: ${theme.spacing.lg};
  font-family: ${theme.fonts.heading};
  border-bottom: 3px solid ${theme.colors.primary};
  padding-bottom: ${theme.spacing.md};

  ${mediaQueries.maxMobile} {
    font-size: ${theme.fontSizes.xl};
  }
`;

const ContentText = styled.p`
  font-size: ${theme.fontSizes.lg};
  line-height: 1.8;
  color: ${theme.colors.text};
  margin-bottom: ${theme.spacing.lg};

  ${mediaQueries.maxMobile} {
    font-size: ${theme.fontSizes.md};
  }
`;

const VisionBox = styled.div`
  background: linear-gradient(135deg, ${theme.colors.primary} 0%, ${theme.colors.secondary} 100%);
  color: white;
  padding: ${theme.spacing.xxl};
  border-radius: ${theme.borderRadius.lg};
  text-align: center;
  box-shadow: ${theme.shadows.md};

  ${mediaQueries.maxMobile} {
    padding: ${theme.spacing.xl} ${theme.spacing.lg};
  }
`;

const VisionText = styled.p`
  font-size: ${theme.fontSizes.xl};
  line-height: 1.8;
  margin: 0;

  ${mediaQueries.maxMobile} {
    font-size: ${theme.fontSizes.lg};
  }
`;

const InfoCard = styled.div`
  background-color: ${theme.colors.hover};
  padding: ${theme.spacing.xl};
  border-radius: ${theme.borderRadius.md};
  margin-bottom: ${theme.spacing.lg};
`;

const InfoLabel = styled.p`
  font-size: ${theme.fontSizes.sm};
  color: ${theme.colors.textLight};
  margin-bottom: ${theme.spacing.sm};
  font-weight: 600;
`;

const InfoValue = styled.p`
  font-size: ${theme.fontSizes.lg};
  color: ${theme.colors.primary};
  font-weight: 700;
  margin: 0;
`;

export const Agape: React.FC = () => {
  return (
    <MainLayout>
      <PageContainer>
        <PageTitle>애찬부</PageTitle>

        <ImagePlaceholder>이미지 영역</ImagePlaceholder>

        <Section>
          <SectionTitle>비전</SectionTitle>
          <VisionBox>
            <VisionText>
              사랑의 식탁 교제를 통해 성도들 간의 친교를 돕고, 섬김으로 하나님께 영광을 돌립니다.
            </VisionText>
          </VisionBox>
        </Section>

        <Section>
          <SectionTitle>소개</SectionTitle>
          <ContentText>
            애찬부는 교회의 각종 행사와 모임에서 식사 준비와 섬김을 담당하는 부서입니다.
            성도들 간의 교제와 친교를 돕고, 사랑의 식탁을 통해 하나님의 사랑을 나누고 있습니다.
          </ContentText>
        </Section>

        <Section>
          <SectionTitle>주요 활동</SectionTitle>
          <InfoCard>
            <InfoLabel>섬김 영역</InfoLabel>
            <InfoValue>주일 애찬, 특별 행사 식사 준비 및 섬김</InfoValue>
          </InfoCard>
        </Section>
      </PageContainer>
    </MainLayout>
  );
};
